import { Injectable } from "@angular/core";
import { TripsService, AssetsService, CustomerService, AuthService, IncidentService, SchedulerService, UsersService, DeviceService, ReportService, NotificationService } from '../../hezky-routes';
import { AdminService } from "./hezky-be-services/admin.service";
@Injectable({
    providedIn: 'root',
})

export class BeUtilityService {
    constructor(
        public readonly reportSvc: ReportService,
        public readonly tripsSvc: TripsService,
        public readonly assetsSvc: AssetsService,
        public readonly customerSvc: CustomerService,
        public readonly authSvc: AuthService,
        public readonly incidentSvc: IncidentService,
        public readonly schedulerSvc: SchedulerService,
        public readonly usersSvc: UsersService,
        public readonly deviceSvc: DeviceService,
        public readonly notificationSvc: NotificationService,
        public readonly adminSvc: AdminService,
    ) { }
}
